import { HttpClient, HttpEvent, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AminitiesService {
  private url = environment.apiBaseUrl;
  constructor(private http: HttpClient) {}
  getAminities() {
    return this.http.get<any>(this.url + "/admin/aminity/");
  }
  getAminityDetail(id) {
    return this.http.get<any>(this.url + "/admin/aminity/getByid?_id=" + id);
  }
  upload(body): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    console.log("data", body);
    formData.append("name", body.basicForm.name);
    formData.append("file", body.file);
    const headers = new HttpHeaders();
    return this.http.post<any>(this.url + "/admin/aminity/", formData, {
      responseType: "json",
      headers,
      withCredentials: false,
    });
  }
  update(body): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append("id", body.id);
    formData.append("name", body.basicForm.name);
    formData.append("file", body.file);
    const headers = new HttpHeaders();

    return this.http.post<any>(this.url + "/admin/aminity/update", formData, {
      responseType: "json",
      headers,
      withCredentials: false,
    });
  }
  delete(id): any {
    return this.http.delete(this.url + "/admin/aminity/" + id);
  }
}
